import {
  InputLabel,
  InputLabelProps,
  TextField,
  TextFieldProps,
  Tooltip,
} from "@mui/material";

type GenericInputProps = {
//   labelInputProps?: InputLabelProps;
//   labelValue?: boolean;
  textFieldInputProps: TextFieldProps;
};

export function GenericInput(props: GenericInputProps) {
  return (
    <>
      <TextField {...props.textFieldInputProps}/>
    </>
  );
}
